let loading = null;
let listener = null;

/** Paddle.js is loaded on demand; the active billing view owns its event callback. */
export async function openPaddle(offer, options, onEvent, isCurrent = () => true)
{
   loading ??= new Promise((resolve, reject) =>
   {
      const script = document.createElement('script');
      const timeout = setTimeout(() => fail('Paddle took too long to load. Please try again.'), 20000);
      let settled = false;
      function fail(message)
      {
         if (settled) return;
         settled = true;
         clearTimeout(timeout);
         script.remove();
         reject(new Error(message));
      }
      script.src = 'https://cdn.paddle.com/paddle/v2/paddle.js';
      script.async = true;
      script.onload = () =>
      {
         if (settled) return;
         const paddle = globalThis.Paddle;
         if (!paddle) return fail('Paddle did not load.');
         try
         {
            if (offer.environment === 'sandbox') paddle.Environment.set('sandbox');
            // Payment links may open during initialization. Apply inline settings and
            // listen before initializing; the explicit open below takes precedence.
            if (!isCurrent()) return fail('Checkout was closed.');
            listener = onEvent;
            paddle.Initialize({ token: offer.clientToken, checkout: { settings: options.settings },
               eventCallback: event => listener?.(event) });
            settled = true;
            clearTimeout(timeout);
            resolve(paddle);
         }
         catch (error)
         {
            fail(error.message);
         }
      };
      script.onerror = () => fail('Paddle could not be loaded. Check your connection and content blocker.');
      document.head.append(script);
   }).catch(error =>
   {
      loading = null;
      throw error;
   });
   const paddle = await loading;
   if (!isCurrent()) return () => {};
   listener = onEvent;
   paddle.Checkout.open(options);
   return () =>
   {
      if (listener === onEvent)
      {
         listener = null;
         paddle.Checkout.close();
      }
   };
}
